import { render, staticRenderFns } from "./ClientSelector.vue?vue&type=template&id=2016e846&"
import script from "./ClientSelector.vue?vue&type=script&lang=ts&"
export * from "./ClientSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports